export const global_breakpoint_xl = {
  "name": "--pf-v5-global--breakpoint--xl",
  "value": "1200px",
  "var": "var(--pf-v5-global--breakpoint--xl)"
};
export default global_breakpoint_xl;